import { FC, PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { observer } from 'mobx-react-lite';

import { I18nProvider } from '@libs/i18n';
import * as Sentry from '@sentry/react';

import { AppErrorFallback } from '../components/AppErrorFallback';
import { container } from '../containers/container';
import { MuiProvider } from '../providers';
import { ContainerProvider } from '../providers/container';
import { LoadingProvider } from '../providers/loading';
import { SnackbarProvider } from '../providers/snackbar';

export const AppProvider: FC<PropsWithChildren> = observer(({ children }) => {
  const queryClient = new QueryClient();
  return (
    <Sentry.ErrorBoundary fallback={({ error }) => <AppErrorFallback error={error instanceof Error ? error : undefined} />}>
      <QueryClientProvider client={queryClient}>
        <ContainerProvider container={container}>
          <I18nProvider>
            <MuiProvider>
              <LoadingProvider>
                <SnackbarProvider>{children}</SnackbarProvider>
              </LoadingProvider>
            </MuiProvider>
          </I18nProvider>
        </ContainerProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
});
